import {Link} from "react-router-dom";
import Routing from "../../Routing.ts";

export default function NotFoundPage() {

    return (
        <div className="selfcare-page-content selfcare-page-error">
            <h1 className="heading heading--big heading">Hov, siden findes desværre ikke</h1>
            <p>
                Brug evt. menuen oppe i højre hjørne til at komme rundt på siden, eller tryk <Link to={Routing.Selfcare.Index}> her</Link> for at komme til din forside.
            </p>
        </div>
    )
}
